import api from '../tools/api';

export const send = data => api.request(
    'send-cart',
    {},
    'POST',
    data
);
